import CloneCard from "components/common/cloneCard";
import DescriptionCard from "components/common/DescriptionCard";
import IssueStatus from "./IssueStatus";
import ProjectDataOverview from "./ProjectDataOverview";
import image1 from "../../assets/Homepage Assets/redesign/Icons.svg";
import image2 from "../../assets/Homepage Assets/redesign/1.svg";
import image1Dark from "../../assets/Homepage Assets/redesign/IconsDark.svg";
import image2Dark from "../../assets/Homepage Assets/redesign/1Dark.svg";
import { useSelector, useDispatch } from "react-redux";
import EmptyState from "components/EmptyState";
import useExtract from "helpers/custom-hooks/extract";
import { useState, useEffect } from "react";
import SideDrawer from "components/SideDrawer";
import ExportSideDrawer from "components/export/ExportSidedrawer";
import CloneSideDrawer from "components/clone/CloneSideDrawer";
import MigrateSideDrawer from "components/migrate/MigrateSideDrawer";
import Sort from "components/common/sort";
import EmptyPiechart from "assets/Icons/icons/EmptyPiechart";
import TableLoading from "components/loadState/TableLoading";
import { useIsDarkTheme } from "helpers/darktheme";
import useClone from "helpers/custom-hooks/clone";
import ClonedProject from "./ClonedProject";
import { Spinner } from "components/Spinner/Spinner";
import localForage from "localforage";
import Overlay from "components/common/overlayComponent";
import GetStarted from "components/tour-guide/getstarted";
import TourGuideSteps from "components/tour-guide/steps";
import { setHideOverlay } from "store/sc";
import CloneModal from "components/common/cloneModal";
import { IoArrowBack } from "react-icons/io5";

const ProjectTab = ({ joyrideStart, setJoyrideStart }) => {
    const current = useSelector((state) => state.project.currentProject) || "";
    const projectStatus = useSelector((state) => state.project.status) || null;
    const statusLoading =
        useSelector((state) => state.project.statusLoading) || null;
    const data = useSelector((state) => state.project.visualizeData) || "";
    const isVisualizing =
        useSelector((state) => state.project.isVisualizing) || "";
    const { extract, isExtracting } = useExtract();
    const [openExtract, setOpenExtract] = useState(false);
    const [openClone, setOpenClone] = useState(false);
    const [openMigrate, setOpenMigrate] = useState(false);
    const { clone, isCloning, cloneSuccess, setCloneSuccess } = useClone();
    const [tab, setTab] = useState(1);
    const [cloneDrawerState, setCloneDrawerState] = useState("initial"); // "initial" or "success"
    const hideOverlay = useSelector((state) => state.project.hideOverlay);
    const dispatch = useDispatch();

    useEffect(() => {
        const stored = localStorage.getItem("hideOverlay") === "true";
        if (stored) {
            dispatch(setHideOverlay(true));
        }
    }, [dispatch]);

    function handleExtract() {
        localForage.getItem("single_project_credentials").then((res) => {
            extract({ ...res, project_key: current.key });
        });
    }

    function handleClone() {
        setCloneDrawerState("initial");
        setCloneSuccess(false);
        localForage.getItem("single_project_credentials").then((res) => {
            clone({ ...res, project_key: current.key });
        });
    }

    useEffect(() => {
        if (cloneSuccess) {
            setCloneDrawerState("success");
        }
    }, [cloneSuccess]);

    const handleGoToClonedProject = () => {
        setTab(2);
        setOpenClone(false);
        setCloneDrawerState("initial");
    };

    const isDarkTheme = useIsDarkTheme();

    const handleMigrateCloneExtractClick = (item) => {
        if (item.id === "export") {
            setOpenExtract(true);
        } else if (item.id === "clone") {
            setOpenClone(true);
        } else {
            setOpenMigrate(true);
        }
    };

    const clonecardData = [
        {
            icon: isDarkTheme ? image1 : image1Dark,
            id: "export",
            text: "Export",
        },
        {
            icon: isDarkTheme ? image2 : image2Dark,
            id: "clone",
            text: "Clone",
        },
    ];

    const descriptionData = [
        { heading: "Project Name", key: data?.["Project Name"] },
        { heading: "Project Key", key: data?.["Project Key"] },
        { heading: "No of Issues", key: data?.counter_data?.Issues },
        {
            heading: "No of IssuesTypes",
            key: data?.counter_data?.["Issue Types"],
        },
    ];

    return (
        <>
            <section className="py-10 pl-10 dark:bg-[#0D1822]">
                <div>
                    {tab !== 1 && (
                        <div
                            onClick={() => setTab(1)}
                            className="mb-3 flex items-center gap-2"
                        >
                            <IoArrowBack size={20} />
                            Back
                        </div>
                    )}
                    <div className="flex gap-x-6 justify-between mb-6 items-center">
                        <p className="text-[#454545] font-medium text-xl tracking-[0.5px] dark:text-white">
                            Project
                        </p>

                        <div className="flex gap-x-2 second">
                            {clonecardData.map((item, i) => (
                                <CloneCard
                                    key={i}
                                    img={item?.icon}
                                    text={item?.text}
                                    disabled={Object.keys(data).length === 0}
                                    onClick={() =>
                                        handleMigrateCloneExtractClick(item)
                                    }
                                    className={item?.id}
                                />
                            ))}
                        </div>
                    </div>
                    {!statusLoading && (
                        <div className="flex items-center gap-2">
                            <p className="font-medium text-[24px] leading-8 text-[#262626] dark:text-white my-6">
                                {current.name}
                            </p>
                            <div
                                className={`py-[px] px-[10px] rounded-2xl ${
                                    projectStatus === true
                                        ? "bg-[#188C43]"
                                        : "bg-[#F04438]"
                                }`}
                            >
                                <span className="font-medium text-sm text-[#FFFFFF]">
                                    {projectStatus === true
                                        ? "Active"
                                        : "Inactive"}
                                </span>
                            </div>
                        </div>
                    )}
                </div>

                {tab === 1 ? (
                    <>
                        {isVisualizing ? (
                            <>
                                <div className="grid grid-cols-4 gap-x-4">
                                    {descriptionData.map((item, i) => {
                                        return (
                                            <DescriptionCard
                                                key={i}
                                                loading={isVisualizing}
                                            />
                                        );
                                    })}
                                </div>
                                <div className="flex gap-4 mt-4">
                                    <div className="border border-[#d9d9d9] dark:border-[#424E59] rounded-lg w-full">
                                        <div className="py-[14px] px-6 flex items-center justify-between border-b border-[#d9d9d9] dark:border-[#424E59]">
                                            <p className="text-base font-medium text-[#262626] dark:text-white">
                                                Issue Statuses
                                            </p>
                                            <Sort data={[]} onSort={() => {}} />
                                        </div>
                                        <div className="text-center mt-12 mb-16 px-[100px] animate-pulse">
                                            <EmptyPiechart />
                                        </div>
                                    </div>

                                    <div className="border border-[#D9D9D9] dark:border-[#424E59] rounded-lg w-full font-medium">
                                        <div className="py-5 px-6 text-[16px] leading-6 text-[#262626] dark:text-white">
                                            Project Data
                                        </div>
                                        <TableLoading rows={6} columns={2} />
                                    </div>
                                </div>
                            </>
                        ) : Object.keys(current).length === 0 ? (
                            <div className="mt-[125px]">
                                <EmptyState />
                            </div>
                        ) : (
                            <>
                                <div className="grid grid-cols-4 gap-x-4">
                                    {descriptionData.map((item, i) => {
                                        return (
                                            <DescriptionCard
                                                key={i}
                                                heading={item?.heading}
                                                subhead={item?.key}
                                            />
                                        );
                                    })}
                                </div>

                                <div className="mt-4 grid grid-cols-2 gap-x-4">
                                    <IssueStatus dataItem={data?.data} />
                                    <ProjectDataOverview
                                        dataItem={data?.counter_data}
                                    />
                                </div>
                            </>
                        )}
                    </>
                ) : (
                    <ClonedProject setTab={setTab} />
                )}
            </section>
            <SideDrawer
                isOpen={openExtract}
                onClose={() => {
                    setOpenExtract(false);
                }}
                onButtonClick={handleExtract}
                buttonLabel={isExtracting ? <Spinner /> : "Download Project"}
                title="Export"
                subtitle="Review the migration details below and proceed with migrating your project."
            >
                <ExportSideDrawer />
            </SideDrawer>

            <SideDrawer
                isOpen={openClone}
                onClose={() => {
                    setOpenClone(false);
                    setCloneDrawerState("initial"); // reset on close
                }}
                onButtonClick={
                    cloneSuccess && cloneDrawerState === "success"
                        ? handleGoToClonedProject
                        : handleClone
                }
                buttonLabel="Start Cloning"
                title="Clone"
                subtitle="Review the migration details below and proceed with migrating your project."
            >
                {isCloning ? (
                    <CloneModal
                        heading={"Cloning Your Project"}
                        subhead={"Please hold on as we clone your project"}
                        isDarkTheme={isDarkTheme}
                        onClose={() => {
                            setOpenClone(false);
                            setCloneDrawerState("initial"); // reset on close
                        }}
                    />
                ) : cloneSuccess && cloneDrawerState === "success" ? (
                    <CloneModal
                        isSuccessIndicator={true}
                        heading={"Successful Cloning"}
                        subhead={
                            "Your project has been successfully cloned. Check the available projects for your newly cloned project"
                        }
                        onButtonClick={handleGoToClonedProject}
                        isDarkTheme={isDarkTheme}
                        onClose={() => {
                            setOpenClone(false);
                            setCloneDrawerState("initial"); // reset on close
                        }}
                    />
                ) : null}
                <CloneSideDrawer />
            </SideDrawer>
            <SideDrawer
                isOpen={openMigrate}
                onClose={() => setOpenMigrate(false)}
                onButtonClick={() => alert("migrate button click")}
                buttonLabel="Continue"
            >
                <MigrateSideDrawer />
            </SideDrawer>

            {!hideOverlay && (
                <Overlay hideOverLay={hideOverlay}>
                    <GetStarted
                        onClick={() => {
                            dispatch(setHideOverlay(true));
                            setJoyrideStart(true); // Start Joyride
                            // localStorage.setItem("hideOverlay", "true");
                        }}
                        onBack={() => {
                            dispatch(setHideOverlay(true));
                            // localStorage.setItem("hideOverlay", "true");
                            setJoyrideStart(false);
                        }}
                    />
                </Overlay>
            )}

            {/* Render Joyride */}
            <TourGuideSteps
                joyrideStart={joyrideStart}
                setJoyrideStart={setJoyrideStart}
            />
        </>
    );
};

export default ProjectTab;
